import React from "react";
import Swiper from "react-id-swiper";
import "./clients.scss";
import "swiper/css/swiper.css";

// Assets
import Preview01 from "../../assets/blog/story01/mcdo.png";
import Preview02 from "../../assets/blog/story02/mcd.png";
import Preview03 from "../../assets/blog/story03/tavi.png";
import Preview04 from "../../assets/blog/story04/amtan.png";
import Preview05 from "../../assets/blog/story05/caref.png";
import Preview06 from "../../assets/blog/story06/sukkar.png";
import Preview07 from "../../assets/blog/story07/tarboushi.png";
import Preview08 from "../../assets/blog/story08/asil.png";

// Components
import Title from "../ui-components/title/title";
import BlogBox from "./clientsBox";

class Clients extends React.Component {
  state = {
    // LIST ARRAY OF BLOG STORIES
    stories: [
      {
        image: Preview01,
        id: "1",
        title: "McDonald's",
      },
      {
        image: Preview02,
        id: "2",
        title: "Tribus",
      },
      {
        image: Preview03,
        id: "3",
        title: "Tavi Confectionary",
      },
      {
        image: Preview04,
        id: "4",
        title: "Amtan",
      },
      {
        image: Preview05,
        id: "5",
        title: "Sukkar Murabbi",
      },
      {
        image: Preview06,
        id: "6",
        title: "AlTarboush Aldimashqi Restaurants",
      },
      {
        image: Preview07,
        id: "7",
        title: "Asil Real Estate",
      },
    ],
  };

  render() {
    const { language } = this.props;

    // BLOG STORIES RENDER
    let storiesRender = null;
    if (this.state.stories) {
      storiesRender = this.state.stories.map((story) => (
        <div key={story.id}>
          <BlogBox article={story} />
        </div>
      ));
    }

    // OPTIONS FOR BLOG SLIDER
    const params = {
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      breakpoints: {
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    };

    return (
      <div className="blog" id="blog">
        <div className="wrapper">
          {/* Conditional title based on language */}
          <Title title={language === "en" ? "CLIENTS" : "العملاء"} />
          <div className="font25">
            {language === "en"
              ? "Swipe left to view more clients"
              : "اسحب لليسار لعرض المزيد من العملاء"}
          </div>
          <div className="padding30">
            <Swiper {...params}>{storiesRender}</Swiper>
          </div>
        </div>
      </div>
    );
  }
}

export default Clients;
